import { render, staticRenderFns } from "./BankproofSrc.vue?vue&type=template&id=581facc2"
import script from "./BankproofSrc.vue?vue&type=script&lang=js"
export * from "./BankproofSrc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports